"use client"

import { useState } from "react"
import { Link } from "react-router-dom"

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false)

  return (
    <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="text-xl font-bold text-gray-900 italic">
              RangDesaaj
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link
                to="/"
                className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors"
              >
                Home Page
              </Link>
              <Link
                to="/shop"
                className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors"
              >
                Shop Now
              </Link>
              <div className="relative">
                <button
                  onClick={() => setIsAboutDropdownOpen(!isAboutDropdownOpen)}
                  className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium flex items-center transition-colors"
                >
                  About Us
                  <svg className="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isAboutDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                    <Link to="/about" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      About Us
                    </Link>
                    <Link to="/contact" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Contact Us
                    </Link>
                    <Link to="/disclaimer" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Disclaimer
                    </Link>
                    <Link to="/privacyPolicy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      PrivacyPolicy
                    </Link>
                    <Link to="/termsAndConditions" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      TermsAndConditions
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Join Button */}


          {/* Mobile menu button */}
          <div className="md:hidden">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 hover:text-gray-900 p-2">
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <Link to="/" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900">
                Home Page
              </Link>
              <Link to="/shop" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900">
                Shop Now
              </Link>
              <Link to="/about" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900">
                About Us
              </Link>
              <Link to="/contact" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900">
                Contact Us
              </Link>
              <Link to="/disclaimer" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900">
                Disclaimer
              </Link>
              <Link to="/privacyPolicy" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900">
                PrivacyPolicy
              </Link>
              <Link to="/termsAndConditions" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900">
                TermsAndConditions
              </Link>

            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Nav
